import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { CmisLink, MrnLink, PersonLink, TreePersonLink } from '../../../app/Links'

export default function CmisxMismatchMessageSummary({ messageDetails }) {
  const { t } = useTranslation()

  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('cmisxMismatch.personId', 'Person ID')}
          data={
            <>
              <PersonLink personId={messageDetails.personId} newTab />
              <TreePersonLink personId={messageDetails.personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('cmisxMismatch.nameFromMembership', 'Name From Membership')}
          data={messageDetails.nameFromMembership}
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('mrn', 'MRN')} data={<MrnLink mrn={messageDetails.mrn} newTab />} />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('cmisId', 'CMIS ID')} data={<CmisLink cmisId={messageDetails.cmisId} newTab />} />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('unitNumber', 'Unit Number')} data={messageDetails.unitNumber} />
      </Cell>
    </Grid>
  )
}
